import { BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GeneralService {
  sideMenu$ = new BehaviorSubject<{
    show?: boolean;
    menuItems?: any[];
    menuType?: string;
    activeStep?: string;
  }>((null as any))

    getErrMsg(err: HttpErrorResponse) {
      const errMsg = err.error ? err.error.message : 'Error occured try again later'
      return errMsg;
    }
    getDateVal(date: string) {
       const result = date ? new Date(date).toJSON().split('T')[0] : date;
       return result;
    }
}
